/**
 * PostHog product analytics pageviews
 * Because the Turn React app is a SPA we need to track pageviews
 * using a component and disable `capture_pageview` in the posthog init.
 *
 * See https://posthog.com/tutorials/single-page-app-pageviews
 */
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export const PostHogPageView = () => {
  const location = useLocation();

  useEffect(() => {
    const posthog = window.posthog;

    if (posthog) {
      posthog.capture("$pageview", {
        $current_url: window.location.href,
      });
    }
  }, [location]);

  return null;
};
